export const LS_TENANT_KEY = 'tenantKey'

export const overrideTenant = (tenantKey: string) => {
  localStorage.setItem(LS_TENANT_KEY, tenantKey)
}

export const getOverrideTenantKey = () => {
  return localStorage.getItem(LS_TENANT_KEY)
}
